import { UseConvertZonedDateTime, UseParseNaiveDateTime } from './UseConvertZonedDateTime';

// A temporary schedule (holiday mode) must start at least this many minutes in the future
export const TEMP_SCHEDULE_MIN_START_LEAD_MINUTES = 5;

export const TEMP_SCHEDULE_START_ERROR = `Start time must be at least ${TEMP_SCHEDULE_MIN_START_LEAD_MINUTES} minutes in the future`;

// Converts a stored naive 'YYYY-MM-DD HH:MM:SS' value (in the schedule's timezone) into a Date on the viewer's clock
export const UseParseTempScheduleDateTime = (storedDateTime, timeZone) => {
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localDateTime = UseConvertZonedDateTime(storedDateTime, timeZone || browserTimeZone, browserTimeZone);
    return UseParseNaiveDateTime(localDateTime);
};

// True when the start is at least TEMP_SCHEDULE_MIN_START_LEAD_MINUTES ahead of the current minute.
// Compared against the start of the current minute (what the viewer sees on their clock), since the picker only goes to the minute.
export const UseIsTempScheduleStartValid = (storedStart, timeZone, now = Date.now()) => {
    if (!storedStart) {
        return false;
    }

    const start = UseParseTempScheduleDateTime(storedStart, timeZone);
    if (isNaN(start.getTime())) {
        return false;
    }

    const currentMinute = Math.floor(now / 60000) * 60000;
    return start.getTime() >= currentMinute + TEMP_SCHEDULE_MIN_START_LEAD_MINUTES * 60000;
};
